export enum InternalReferralTypes {
  PSYCHIATRY = 'psychiatry',
  THERAPY = 'therapy'
}
